import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class UsersService {

  constructor(private http: HttpClient) { }

  list(page,field,reverse) {
    return this.http.get(`api/users/${page}/${field}/${reverse}`);
  }

  edit(id, data) {
    return this.http.put(`/api/users/${id}`, data);
  }

  delete(id) {
    return this.http.delete(`/api/users/${id}`);
  }

}



// WEBPACK FOOTER //
// ./client/app/core/users/users.service.ts